import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import CreateProjectForm from "@/components/app/CreateProjectForm";
import ListProjectTable from "@/components/app/ListProjectTable";
import {ref} from "vue";
import IsAdmin from "@/components/blocks/IsAdmin.vue";

// Define component properties

export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectView',
  setup(__props) {

const projectTable = ref()

// Define function
function handleProjectCreated(data: any) {
  projectTable.value.reload()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(IsAdmin, null, {
      default: _withCtx(() => [
        _createVNode(_unref(CreateProjectForm), { onItemCreated: handleProjectCreated })
      ]),
      _: 1
    }),
    _createVNode(_unref(ListProjectTable), {
      ref_key: "projectTable",
      ref: projectTable
    }, null, 512)
  ], 64))
}
}

})